import type { BetterstartCommandRuntime } from '@cli-types/core-engine/commands.js'
import { runAddFieldCommand } from './commands/add-field/run-add-field-command.js'
import { runAddCommand } from './commands/add/run-add-command.js'
import { runCreateCommand } from './commands/create/run-create-command.js'
import { runGenerateCommand } from './commands/generate/run-generate-command.js'
import { runInitCommand } from './commands/init/run-init-command.js'
import { runListIntegrationsCommand } from './commands/list-integrations.js'
import { runListPresetsCommand } from './commands/list-presets.js'
import { listComponentChoices } from './commands/menu-choices/list-component-choices.js'
import { listInstallableChoices } from './commands/menu-choices/list-installable-choices.js'
import { listSchemaChoices } from './commands/menu-choices/list-schema-choices.js'
import { runRemoveSchemaCommand } from './commands/remove-schema/run-remove-schema-command.js'
import { runRemoveCommand } from './commands/remove.js'
import { runSeedCommand } from './commands/seed/run-seed-command.js'
import { runUninstallCommand } from './commands/uninstall/run-uninstall-command.js'
import { runUpdateCommand } from './commands/update-component/run-update-command.js'
import { runUpdateDepsCommand } from './commands/update-deps.js'
import { runUpdateStylesCommand } from './commands/update-styles.js'

export const nextCommandRuntime: BetterstartCommandRuntime = {
  listComponentChoices,
  listInstallableChoices,
  listSchemaChoices,
  runAdd: runAddCommand,
  runAddField: runAddFieldCommand,
  runCreate: runCreateCommand,
  runGenerate: runGenerateCommand,
  runInit: runInitCommand,
  runListIntegrations: runListIntegrationsCommand,
  runListPresets: runListPresetsCommand,
  runRemove: runRemoveCommand,
  runRemoveSchema: runRemoveSchemaCommand,
  runSeed: runSeedCommand,
  runUninstall: runUninstallCommand,
  runUpdate: runUpdateCommand,
  runUpdateDeps: runUpdateDepsCommand,
  runUpdateStyles: runUpdateStylesCommand
}
